module.exports = __webpack_public_path__ + "img/Australian.8341fcdc.svg";